<template>
  <div class="content" style="padding-bottom: 0;">
    <div class="container-fluid">
      <div class="dashboard-title mb-4" v-if="$mq !='mobile'">
        <span> Energy Dashboard</span>
      </div>
      <div v-if="$mq == 'mobile'">
        <div class="d-block justify-center">
          <ul class="buttonwrapper">
            <li :class="{'active': activeIndex=='today'}" @click="setActive('today')">
              <label>today</label>
            </li>
            <li :class="{'active': activeIndex=='month'}" @click="setActive('month')">
              <label>month</label>
            </li>
            <li :class="{'active': activeIndex=='year'}" @click="setActive('year')">
              <label>year</label>
            </li>
          </ul>
        </div>
        <div class="d-block justify-center">
          <div class="time-text">
            <span> {{ setDisplayTime(activeIndex) }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between" v-else>
        <ul class="buttonwrapper">
          <li :class="{'active': activeIndex=='today'}" @click="setActive('today')">
            <label>today</label>
          </li>
          <li :class="{'active': activeIndex=='month'}" @click="setActive('month')">
            <label>month</label>
          </li>
          <li :class="{'active': activeIndex=='year'}" @click="setActive('year')">
            <label>year</label>
          </li>
        </ul>
        <div class="time-text">
          <span> {{ setDisplayTime(activeIndex) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import SetDisplayTime from '@/mixins/setDisplayTime';

export default {
  name: 'SetPeriodTime',
  mixins: [ SetDisplayTime ],
  data() {
    return {
      activeIndex: 'today',
      display: '',
			blockTime: true
    };
  },
  computed: {
    ...mapGetters({
      periodTime: 'settime/getPeriodTime',
			isUse: 'settime/getIsUse'
    })
  },
	watch: {
		$route(to, from){
			if (to.name !== 'realtimepower') {
				this.$store.dispatch('settime/blockUse', true);
			}
		}
	},
  created() {
    this.activeIndex = this.periodTime;
  },
  methods: {
    ...mapMutations({
      setPeriodTime: 'settime/setPeriodTime'
    }),
    ...mapActions({
      test: 'settime/setAction'
    }),
    setActive(index) {
      this.activeIndex = index;
      this.setPeriodTime(this.activeIndex);
    }
  }
};
</script>
<style lang="scss">
.dashboard-title {
  span {
    font-family: 'Nunito Sans Light';
    font-weight: 200;
    font-size: 32px;
  }
}

.disable-time {
	opacity: 0.3;
	background: grey;
	pointer-events: none;
}
.buttonwrapper {
  list-style: none;
  padding: 5px;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: auto;
  border-radius: 50px;
  background-color: hsla(0,0%,100%,.13);

  li:first-child {
    margin-left: 0;
  }

  li {
    display: block;
    float: left;
    margin-left: 35px;
    height: 35px;
    width: 80px;
    label {
      display: block;
      color: #fff;
      font-family: Nunito Sans Light;
      opacity: 1;
      font-size: 13px;
      line-height: 1.5;
      text-align: center;
      padding: 8px 10px;
      margin-bottom: 0;
      border-radius: 50%;
      cursor: pointer;
      text-transform: uppercase;
			transition: background-color 600ms, border-radius 600ms;
		}

    &.active label {
      background-color: #182142;
      border-radius: 50px;
    }
  }
}

.time-text {
  font-size: 20px;
  font-family: 'Nunito Sans Light';
}
</style>
